import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { FONTSIZE_FORMATS, IMAGE_CLASS_LIST } from './tinymceConstants';
import { reqCkUpload } from '../../api';
import Language from '../../i18n/Language';
import EditorFindBar from './EditorFindBar';
import './tinymce.scss';

const t = Language;

const TinyMce = forwardRef((props, ref) => {

    const {
        id,
        minHeight,
        maxHeight,
        trans_content,
        disabled,
        isFocus,
        enableFind,
        findKeyword,

    } = props;

    const editorRef = useRef(null);

    // 查找浮层：定位与计数
    const [findCurrent, setFindCurrent] = useState(0);
    const [findTotal, setFindTotal] = useState(0);
    const findKeywordRef = useRef('');
    const findIndexRef = useRef(-1);
    const pendingFirstRef = useRef(false);
    const recomputeRef = useRef(() => { });

    // 自定义图标
    const iconMap = {
        magic: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M3.702 2.253a.624.624 0 0 1 1.096 0l.196.358c.207.378.517.688.895.895l.358.196a.625.625 0 0 1 0 1.097l-.358.196a2.25 2.25 0 0 0-.895.894l-.196.359a.625.625 0 0 1-1.096 0l-.196-.359a2.25 2.25 0 0 0-.895-.894l-.358-.196a.625.625 0 0 1 0-1.097l.358-.196c.378-.207.688-.517.895-.895z"></path><path fill-rule="evenodd" d="M10.948 5.89c-.18-1.167-1.852-1.19-2.064-.029l-.03.164a3.755 3.755 0 0 1-3.088 3.031c-1.15.188-1.173 1.833-.03 2.054l.105.02a3.83 3.83 0 0 1 3.029 3.029l.032.165c.233 1.208 1.963 1.208 2.196 0l.025-.129a3.84 3.84 0 0 1 3.077-3.045c1.184-.216 1.12-1.928-.071-2.107a3.79 3.79 0 0 1-3.18-3.154Zm-.944 6.887a5.34 5.34 0 0 1 2.542-2.647 5.3 5.3 0 0 1-2.628-2.548 5.26 5.26 0 0 1-2.488 2.508 5.33 5.33 0 0 1 2.574 2.687"></path></svg>`,
        image: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20"><path d="M10.5 7a1.5 1.5 0 1 0-.001-3.001 1.5 1.5 0 0 0 .001 3.001"></path><path fill-rule="evenodd" d="M7.018 1.5h1.964c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366.706.36 1.28.933 1.64 1.639.226.444.32.924.365 1.47.043.531.043 1.187.043 2v1.964c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.76 3.76 0 0 1-1.638 1.64c-.445.226-.925.32-1.471.365-.531.043-1.187.043-2 .043h-1.964c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.76 3.76 0 0 1-1.64-1.638c-.226-.445-.32-.925-.365-1.471-.043-.531-.043-1.187-.043-2v-1.964c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47.36-.706.933-1.28 1.639-1.64.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043m-1.877 1.538c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v1.429l.723-.868a1.75 1.75 0 0 1 2.582-.117l2.695 2.695 1.18-1.18a1.75 1.75 0 0 1 2.604.145l.216.27v-2.374c0-.852 0-1.447-.038-1.91-.037-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.984-.984c-.197-.1-.458-.17-.912-.207-.462-.037-1.057-.038-1.909-.038h-1.9c-.852 0-1.447 0-1.91.038Zm-2.103 7.821-.006-.08.044-.049 1.8-2.159a.25.25 0 0 1 .368-.016l3.226 3.225a.75.75 0 0 0 1.06 0l1.71-1.71a.25.25 0 0 1 .372.021l1.213 1.516q-.032.09-.07.165c-.216.423-.56.767-.984.983-.197.1-.458.17-.912.207-.462.037-1.057.038-1.909.038h-1.9c-.852 0-1.447 0-1.91-.038-.453-.037-.714-.107-.911-.207a2.25 2.25 0 0 1-.984-.984c-.1-.197-.17-.458-.207-.912"></path></svg>`,
        link: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18"><path fill-rule="evenodd" d="M13.842 2.176a3.746 3.746 0 0 0-5.298 0l-2.116 2.116a3.75 3.75 0 0 0 .01 5.313l.338.337a.751.751 0 0 0 1.057-1.064l-.339-.338a2.25 2.25 0 0 1-.005-3.187l2.116-2.117a2.247 2.247 0 1 1 3.173 3.18l-1.052 1.048a.749.749 0 1 0 1.057 1.063l1.053-1.047a3.745 3.745 0 0 0 .006-5.304m-11.664 11.67a3.75 3.75 0 0 0 5.304 0l2.121-2.122a3.75 3.75 0 0 0 0-5.303l-.362-.362a.749.749 0 1 0-1.06 1.06l.361.363c.88.878.88 2.303 0 3.182l-2.12 2.121a2.25 2.25 0 0 1-3.183-3.182l1.07-1.069a.75.75 0 0 0-1.062-1.06l-1.069 1.068a3.75 3.75 0 0 0 0 5.304"></path></svg>`,
        table: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20"><path fill-rule="evenodd" d="M3.5 14.5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2zm3.25-11.5h2.5v2h-2.5zm-1.5 0h-1.75a.5.5 0 0 0-.5.5v1.5h2.25zm0 3.5h-2.25v6a.5.5 0 0 0 .5.5h1.75zm1.5 6.5v-6.5h2.5v6.5zm4-8v-2h1.75a.5.5 0 0 1 .5.5v1.5zm0 1.5v6.5h1.75a.5.5 0 0 0 .5-.5v-6z"></path></svg>`,
        sourcecode: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20"><path d="M10.221 2.956a.75.75 0 0 0-1.442-.412l-3 10.5a.75.75 0 0 0 1.442.412z"></path><path d="M5.03 4.22a.75.75 0 0 1 0 1.06l-2.72 2.72 2.72 2.72a.749.749 0 1 1-1.06 1.06l-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25a.75.75 0 0 1 1.06 0"></path><path d="M10.97 11.78a.75.75 0 0 1 0-1.06l2.72-2.72-2.72-2.72a.749.749 0 1 1 1.06-1.06l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0"></path></svg>`,
        extend: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M10.25 4C10.6642 4 11 3.66421 11 3.25C11 2.83579 10.6642 2.5 10.25 2.5L3.06066 2.5L4.28033 1.28033C4.57322 0.987437 4.57322 0.512563 4.28033 0.21967C3.98744 -0.0732233 3.51256 -0.0732233 3.21967 0.21967L0.71967 2.71967C0.426777 3.01256 0.426777 3.48744 0.71967 3.78033L3.21967 6.28033C3.51256 6.57322 3.98744 6.57322 4.28033 6.28033C4.57322 5.98744 4.57322 5.51256 4.28033 5.21967L3.06066 4L10.25 4Z"></path><path d="M3.75 9.5C3.33579 9.5 3 9.16421 3 8.75C3 8.33579 3.33579 8 3.75 8H10.9393L9.71967 6.78033C9.42678 6.48744 9.42678 6.01256 9.71967 5.71967C10.0126 5.42678 10.4874 5.42678 10.7803 5.71967L13.2803 8.21967C13.5732 8.51256 13.5732 8.98744 13.2803 9.28033L10.7803 11.7803C10.4874 12.0732 10.0126 12.0732 9.71967 11.7803C9.42678 11.4874 9.42678 11.0126 9.71967 10.7197L10.9393 9.5H3.75Z"></path></svg>`,
        simplify: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 12"><path d="M13.25 4.25C13.6642 4.25 14 3.91421 14 3.5C14 3.08579 13.6642 2.75 13.25 2.75L8.56066 2.75L9.78033 1.53033C10.0732 1.23744 10.0732 0.762563 9.78033 0.46967C9.48744 0.176777 9.01256 0.176777 8.71967 0.46967L6.21967 2.96967C5.92678 3.26256 5.92678 3.73744 6.21967 4.03033L8.71967 6.53033C9.01256 6.82322 9.48744 6.82322 9.78033 6.53033C10.0732 6.23744 10.0732 5.76256 9.78033 5.46967L8.56066 4.25H13.25Z"></path><path d="M0.75 7.75C0.335787 7.75 0 8.08579 0 8.5C0 8.91421 0.335786 9.25 0.75 9.25H5.43934L4.21967 10.4697C3.92678 10.7626 3.92678 11.2374 4.21967 11.5303C4.51256 11.8232 4.98744 11.8232 5.28033 11.5303L7.78033 9.03033C8.07322 8.73744 8.07322 8.26256 7.78033 7.96967L5.28033 5.46967C4.98744 5.17678 4.51256 5.17678 4.21967 5.46967C3.92678 5.76256 3.92678 6.23744 4.21967 6.53033L5.43934 7.75H0.75Z"></path></svg>`,
    }

    const [focusEditor, setFocusEditor] = useState(false);
    const [disableEditor, setDisableEditor] = useState(false);

    // 更新初始化编辑器
    const updateInitEditor = (_, editor) => {
        editorRef.current = editor;
        props.handleInitEditorState?.();
        // addListenDescAi();
        // 第一次设置内容
        // console.log(editor, trans_content);
        // editor.setContent(trans_content);
    }

    // TinyMCE 6+：`images_upload_handler` 签名为 (blobInfo, progress) => Promise<string>。
    // 旧版 (blobInfo, success, failure) 中第二个参数实际是 progress，误当 success 会导致内部读到 undefined 并报错（如 reading 'url'）。
    const pickCkUploadImageUrl = (res) => {
        if (!res || typeof res !== 'object') return '';
        const d = res.data;
        if (typeof d === 'string' && d.trim()) return d.trim();
        if (d && typeof d === 'object') {
            if (typeof d.url === 'string') return d.url;
            if (typeof d.location === 'string') return d.location;
        }
        if (typeof res.url === 'string') return res.url;
        if (typeof res.location === 'string') return res.location;
        return '';
    };
    const uploadImg = (blobInfo, progress) =>
        new Promise((resolve, reject) => {
            (async () => {
                try {
                    const formData = new FormData();
                    formData.append('file', blobInfo.blob(), blobInfo.filename());
                    if (typeof progress === 'function') {
                        progress(0);
                    }
                    const res = await reqCkUpload(formData);
                    if (typeof progress === 'function') {
                        progress(100);
                    }
                    const url = pickCkUploadImageUrl(res);
                    if (url) {
                        resolve(url);
                        return;
                    }
                    if (res?.code === 200) {
                        reject('Invalid upload response: missing image URL');
                    } else {
                        reject(res?.msg || res?.message || 'Upload failed');
                    }
                } catch (err) {
                    reject(err?.message || 'Upload failed');
                }
            })();
        });

    // 处理编辑器变化
    const handleEditorChange = (value) => {
        if (props.onTransChange) {
            // 传递文本和字数
            let wordcount = editorRef.current.plugins.wordcount;
            props.onTransChange(value, wordcount.body.getWordCount())
        }
    };

    // 编辑H2标题
    const insertH2Title = (id) => {
        const editor = editorRef.current;
        if (Boolean(editor)) {
            editor.focus(); // 聚焦
            editor.selection.scrollIntoView(document.getElementById(id), true); // 滚动到h2
        }
    }

    // 插入内容到末尾
    const insertContent = (content) => {
        const editor = editorRef.current;
        if (Boolean(editor)) {
            editor.execCommand('selectAll');
            editor.selection.getRng().collapse(false); // 光标放到最后
            editor.focus(); // 聚焦
            editor.insertContent(content); // 插入内容
        }
    }

    // // 传递选中文本
    // const setSelectValue = () => {
    //     // let textAllOrigin = editorRef.current.getContent({ format: 'text' });
    //     let textOrigin = editorRef.current.getContent();
    //     let textSelectOrigin = editorRef.current.selection.getContent();
    //     let selectedText = editorRef.current.selection.getContent({ format: 'text' });
    //     let selectedRng = editorRef.current.selection.getRng();
    //     if (props?.setSelectTextVal) {
    //         props.setSelectTextVal(selectedText, textOrigin, textSelectOrigin, selectedRng);
    //     }
    // }

    // // 监听富文本选中的值
    // const addListenDescAi = () => {
    //     // 鼠标事件
    //     editorRef.current.on('click', (e) => {
    //         setSelectValue();
    //     });
    //     // 键盘事件
    //     editorRef.current.on('keyup', (e) => {
    //         // 检查是否按下了Ctrl + 其他快捷键选中文本
    //         if (e.key === "Control") {
    //             setSelectValue();
    //         }
    //     });
    // }

    // ====== 查找浮层：在富文本内容里定位关键词 ======
    // 关键词高亮由父组件写入 descValue，匹配项为 span.match_green/yellow/red
    const getMatchSpans = () => {
        const body = editorRef.current?.getBody?.();
        if (!body) return [];
        return Array.from(body.querySelectorAll('span.match_green, span.match_yellow, span.match_red'));
    };

    // 选中并滚动到某个匹配项
    const scrollToMatch = (span) => {
        const editor = editorRef.current;
        if (!editor || !span) return;
        try {
            // 清除上一个当前项的高亮，再给当前项加上专属高亮
            const body = editor.getBody?.();
            if (body) {
                body.querySelectorAll('.current_match_highlight').forEach((el) => {
                    el.classList.remove('current_match_highlight');
                });
            }
            span.classList.add('current_match_highlight');
        } catch (e) { /* ignore */ }
        editor.selection.scrollIntoView(span);
    };

    // 重新计算匹配项数量与当前位置（内容变化 / 打开查找时调用）
    const recomputeMatches = () => {
        if (!findKeywordRef.current) return;
        const spans = getMatchSpans();
        const total = spans.length;
        let idx = findIndexRef.current;
        if (pendingFirstRef.current) {
            idx = total > 0 ? 0 : -1;
        } else if (idx < 0 || idx >= total) {
            idx = total > 0 ? 0 : -1;
        }
        findIndexRef.current = idx;
        setFindTotal(total);
        setFindCurrent(idx >= 0 ? idx + 1 : 0);
        if (pendingFirstRef.current && idx >= 0) {
            scrollToMatch(spans[idx]);
            pendingFirstRef.current = false;
        }
    };
    recomputeRef.current = recomputeMatches;

    // 上/下定位：delta = 1 下一个，-1 上一个（循环）
    const moveMatch = (delta) => {
        const spans = getMatchSpans();
        const total = spans.length;
        if (total === 0) {
            findIndexRef.current = -1;
            setFindTotal(0);
            setFindCurrent(0);
            return;
        }
        let idx = findIndexRef.current;
        idx = idx < 0 ? 0 : ((idx + delta) % total + total) % total;
        findIndexRef.current = idx;
        setFindTotal(total);
        setFindCurrent(idx + 1);
        scrollToMatch(spans[idx]);
    };

    // 关键词变化：打开/切换/关闭查找
    useEffect(() => {
        if (!enableFind) return;
        if (findKeyword) {
            findKeywordRef.current = findKeyword;
            findIndexRef.current = -1;
            pendingFirstRef.current = true;
            // 高亮 span 可能已渲染，先尝试一次；未就绪时由 SetContent 兜底
            recomputeMatches();
        } else {
            findKeywordRef.current = '';
            findIndexRef.current = -1;
            pendingFirstRef.current = false;
            setFindTotal(0);
            setFindCurrent(0);
            // 关闭查找：移除当前命中项的高亮
            const body = editorRef.current?.getBody?.();
            if (body) {
                body.querySelectorAll('.current_match_highlight').forEach((el) => {
                    el.classList.remove('current_match_highlight');
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [findKeyword, enableFind]);

    // 暴露到父组件的方法
    useImperativeHandle(ref, () => ({
        insertH2Title,
        insertContent,
    }));

    useEffect(() => {
        setFocusEditor(isFocus);
        if (isFocus) {
            insertContent(' ');
        }
    }, [isFocus]);

    useEffect(() => {
        setDisableEditor(disabled);
    }, [disabled]);

    // useEffect(() => {
    //     const editor = editorRef.current;
    //     if (Boolean(editor)) {
    //         editor.setContent(trans_content);
    //     }
    // }, [trans_content]);

    const editorContentStyle = `
        body { color: rgb(31, 33, 36); font-size: 0.875rem; } 
        p { margin: 5px 0; }
        .match_green.current_match_highlight {
            background-color: #81e19f !important;
        }
        .match_yellow.current_match_highlight {
            background-color: #fdcf77 !important;
        }
        .match_red.current_match_highlight {
            background-color: #fb7b7b !important;
        }
        .hover_match_green,
        .match_green {
            background-color: #f0fff4;
            border-bottom: 2px solid #81e19f;
        }
        .hover_match_yellow,
        .match_yellow {
            background-color: #fffaf0;
            border-bottom: 2px solid #fdcf77;
        }
        .hover_match_red,
        .match_red {
            background-color: #fff5f6;
            border-bottom: 2px solid #fb7b7b;
        }

        .index_match_green {
            background-color: #f0fff4;
        }
        .index_match_yellow {
            background-color: #fdcf77;
        }

        .match_purple {
            color: var(--color-primary);
        }

        .mce-content-readonly {
            opacity: 0.5;
        }
    `;

    const toolbarSel = ['original_tiny_mac', 'optimized_tiny_mac'].includes(id) ? ('blocks bold italic underline more | undo redo') : ('aicontent | undo redo | blocks | bold italic underline forecolor | align | link image table | bullist numlist outdent indent | more | ' + 'code');

    return (
        <div className={`tiny-mac ${id}-tiny ${disableEditor ? "disabled-tiny-mac" : ""} ${focusEditor ? 'tinymce_focus' : ''}`} id={`tiny-mac-id`}>
            {enableFind && findKeyword ? (
                <EditorFindBar
                    keyword={findKeyword}
                    current={findCurrent}
                    total={findTotal}
                    onNext={() => moveMatch(1)}
                    onPrev={() => moveMatch(-1)}
                    onClose={() => props.onFindClose && props.onFindClose()}
                />
            ) : null}
            <Editor
                id={id}
                licenseKey="gpl"
                tinymceScriptSrc={'/tinymce/tinymce.min.js'}
                onInit={(evt, editor) => updateInitEditor(evt, editor)}
                value={trans_content}
                onEditorChange={handleEditorChange}
                disabled={disabled}
                init={{
                    entity_encoding: 'raw', // 保留原始字符（如 Á），避免被转成 &Aacute; 等命名实体
                    relative_urls: false, // ✅ 关键
                    min_height: minHeight || 480,
                    max_height: maxHeight || 480,
                    content_style: editorContentStyle,
                    statusbar: false,
                    remove_trailing_brs: false,
                    menubar: false,
                    branding: false,
                    help_accessibility: false,
                    toolbar_sticky: false, // 工具栏是否吸顶
                    link_quicklink: false,
                    quickbars_insert_toolbar: false,
                    a11y_advanced_options: false,
                    quickbars_selection_toolbar: 'bold italic strikethrough removeformat | quicklink h2 h3 blockquote ',
                    valid_children: '' + 'body[div|metabr|h1|h2|h3|h4|h5|h6|abbr|acronym|address|area|article|aside|audio|b|base|bdi|bdo|big|blockquote|body|basefont|col|button|canvas|caption|center|colgroup|command|datalist|em|strong|dfn|code|samp|kbd|var|cite|hr|embed|frame|img|input|keygen|link|source|track|dd|del|details|dfn|dialog|dir|dl|dt|fieldset|figcaption|figure|font|footer|form|frameset|head|html|i|iframe|header|ins|label|legend|li|main|map|mark|menu|menuitem|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|s|select|section|small|span|strike|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|u|video|wbr],',
                    // 允许 <style>/<link> 元素本身及其属性（默认 schema 会剔除 body 内的 style）
                    extended_valid_elements: 'style[type|media|scoped],link[href|rel|type|media]',
                    table_default_attributes: {
                        border: '1'
                    },
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'searchreplace', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'help', 'wordcount',
                        'quickbars', 'directionality', 'autoresize', 'emoticons'
                    ],
                    // 自定义工具栏
                    toolbar_mode: 'floating',
                    toolbar_groups: {
                        more: {
                            icon: 'image-options',
                            tooltip: 'More',
                            items: 'backcolor strikethrough removeformat emoticons preview'
                        }
                    },
                    toolbar: toolbarSel,
                    fontsize_formats: FONTSIZE_FORMATS,
                    image_class_list: IMAGE_CLASS_LIST,
                    image_uploadtab: true,
                    images_upload_handler: uploadImg,
                    setup: (editor) => {
                        // 自定义图标
                        editor.ui.registry.addIcon('magic', iconMap.magic); // ai 图标
                        editor.ui.registry.addIcon('image', iconMap.image); // 图片
                        editor.ui.registry.addIcon('link', iconMap.link); // 超链接
                        editor.ui.registry.addIcon('table', iconMap.table); // 表格
                        editor.ui.registry.addIcon('sourcecode', iconMap.sourcecode); // 源码
                        editor.ui.registry.addIcon('extend', iconMap.extend);   // 扩展
                        editor.ui.registry.addIcon('simplify', iconMap.simplify);   // 简化

                        // 空的 alt="" 会被 TinyMCE 判定为「装饰性图片(decorative)」，
                        // 一旦如此，后续在图片编辑弹窗里填写的 alt 会在保存时被强制清空。
                        // 这里在选中图片/内容变更时移除空 alt 属性，避免误判，保证 alt 可被正常编辑保存。
                        const stripEmptyAlt = () => {
                            editor.dom.select('img[alt=""]').forEach((img) => img.removeAttribute('alt'));
                        };
                        editor.on('SetContent', stripEmptyAlt);
                        editor.on('NodeChange', stripEmptyAlt);

                        // 查找浮层：内容渲染后重新计算匹配项（关键词高亮 span 生成后触发）
                        editor.on('SetContent', () => recomputeRef.current());

                        // 当前命中项的高亮 class 仅用于显示，保存时剥离，避免写入正文
                        editor.on('GetContent', (e) => {
                            if (e && typeof e.content === 'string' && e.content.indexOf('current_match_highlight') !== -1) {
                                e.content = e.content
                                    .replace(/\s*current_match_highlight/g, '')
                                    .replace(/class=""/g, '');
                            }
                        });

                        // AI内容优化功能
                        // editor.ui.registry.addMenuButton('aicontent', {
                        //     icon: `magic`,
                        //     tooltip: t("AI Optimization When you select some content, you can use this function to optimize the content, including content rephrase、extend、simplify Make your content perfect now!"),
                        //     fetch: (callback) => {
                        //         const items = [
                        //             {
                        //                 type: 'menuitem',
                        //                 icon: `magic`,
                        //                 text: t("Rephrase"),
                        //                 onAction: (_) => props.handleAiOpera(editorRef.current, 'Rephrase')
                        //             },
                        //             {
                        //                 type: 'menuitem',
                        //                 icon: `extend`,
                        //                 text: t("Extend"),
                        //                 onAction: (_) => props.handleAiOpera(editorRef.current, 'Extend')
                        //             },
                        //             {
                        //                 type: 'menuitem',
                        //                 icon: `simplify`,
                        //                 text: t("Simplify"),
                        //                 onAction: (_) => props.handleAiOpera(editorRef.current, 'Simplify')
                        //             }
                        //         ];
                        //         callback(items);
                        //     }
                        // });

                        // editor.on('init', () => {
                        //     isProgrammaticChange = true;

                        //     editor.setContent(initialValue);

                        //     editor.undoManager.clear();
                        //     editor.setDirty(false);

                        //     isProgrammaticChange = false;
                        //     console.log(0)
                        // });

                        // editor.on('change input undo redo', () => {
                        //     if (isProgrammaticChange) return;

                        //     console.log(1)
                        //     // showSaveBar();
                        // });
                    }
                }}
                onFocus={() => {
                    if (props?.onTransFocus) {
                        props.onTransFocus();
                    }
                }}
            />
        </div>
    );
})

export default TinyMce;